import { createClient } from "contentful";

export default createClient({
  space: "pf0pjn5jvlc7",
  accessToken: "3x3iqO28vXQVFbxGlFriDOWfB5nZRgjNtgNrpvdpXWc"
});
